<template>
	<div>
		<div
			class="quescard d-flex relativeclass"
			:id="'ques' + data.questionKey + selectedSection.sectionID"
		>
			<div
				class="quescard-colorbar ml-2"
				:class="
					data.answerStatus.later
						? 'side-blocks-later'
						: data.answerStatus.attempted
						? 'side-blocks-attempted'
						: data.questionBody.config.config.required
						? 'side-blocks-active'
						: 'side-blocks-unattempted'
				"
			></div>
			<div class="d-flex flex-column mcqcard">
				<b-row class="mb-2">
					<b-col>
						<div class="d-flex align-items-center gap-10">
							<div class="mark-tag">
								{{ Math.round(data.questionBody.marks) }} Mark{{
									Math.round(data.questionBody.marks) > 1 ? "s" : ""
								}}
							</div>
							<div class="mark-tag">
								Difficulty Level - {{ difficultyLevelText }}
							</div>
						</div>
					</b-col>

					<b-col class="d-flex justify-content-end align-items-baseline gap-24">
						<template v-if="testDetails.config.dispReqStatus">
							<div
								class="reqd-txt mr-3"
								v-if="data.questionBody.config.config.required"
							>
								<img
									src="../../assets/newimgs/testscreen/reqQuesIcon.svg"
									alt=""
									class=""
								/>
								Required
							</div>
						</template>
						<div
							class="
                            markforlatercheckbox 
                            dodontcheckbox
                                d-flex
                                align-items-center
                                justify-content-end
                            "
						>
							<b-form-checkbox
								name="checkbox-1"
								v-model="data.answerStatus.later"
								@change="markforLater()"
							>
								Mark for later
							</b-form-checkbox>
						</div>
						<img
							v-if="!data.answerStatus.attempted"
							@click="goToCommunication()"
							class="pointer"
							src="@/assets/communication/circle-right-arrow.svg"
						/>
					</b-col>
				</b-row>

				<div class="d-flex flex-column">
					<!-- <div v-if="data.questionBody.questionMedia != null" class="mt-2">
						<div
							@mouseover="showmainimgviewicon = true"
							@mouseleave="showmainimgviewicon = false"
							class="question-image-container mb-2 d-flex align-items-center justify-content-center position-relative"
							v-if="isImage(data.questionBody.questionMediaType)"
						>
							<img
								class="object-fit-contain w-100 h-100"
								:src="data.questionBody.questionMedia"
								alt=""
							/>
							<div class="image-blur-overlay" v-if="showmainimgviewicon"></div>
							<span
								v-if="showmainimgviewicon"
								style="top: 108px;left: 71px;"
								class="position-absolute view-image-icon pointer"
								@click.stop.prevent="
									openPreviewMainimage(data.questionBody.questionMedia)
								"
							>
								<img
									src="../../assets/newui-img/test-screen/imagepreview.svg"
									alt=""
									class="mr-1"
								/>
								View Image
							</span>
						</div>
						<div
							v-if="isAudio(data.questionBody.questionMediaType)"
							class="d-flex align-items-center mb-2"
						>
							<Media
								:kind="'audio'"
								:isMuted="false"
								:src="data.questionBody.questionMedia"
								:autoplay="false"
								:controls="true"
								:loop="true"
								class="mcqdatacard-audio"
							></Media>
						</div>
						<div
							v-if="isVideo(data.questionBody.questionMediaType)"
							class="d-flex align-items-center mb-2"
						>
							<Media
								:kind="'video'"
								:isMuted="false"
								:src="data.questionBody.questionMedia"
								:autoplay="false"
								:controls="true"
								:loop="true"
								class="qb-image-preview"
							></Media>
						</div>
					</div> -->

					<div class="sec-ques-style d-flex mb-3 mt-2">
						<div>Q{{ showindex }}.</div>
						<div
							class="ml-1 sec-ques-style topicDescBreak"
							v-html-safe="data.questionBody.question"
						></div>
					</div>
				</div>
				<div v-if="data.answerStatus.attempted" class="answered-sec">
					<div class="dashed-border"></div>
					<section
						class="py-2 d-flex justify-content-between align-items-center gap-10 pt-3"
					>
						<div class="d-flex align-items-center">
							<img
								src="@/assets/communication/your-answer.svg"
								alt=""
								class="mr-2"
							/>
							<span class="text-nowrap dark-gray font-primary fw-600 fs-13">
								Your Answer
							</span>
							<div class="ans-sep"></div>
						</div>

						<div class="audio-bar-commu">
							<section @click="togglePlayAudio" class="pointer">
								<img
									height="20"
									width="20"
									v-if="!isPlayingAudio"
									src="@/assets/communication/play.svg"
								/>
								<img
									height="20"
									width="20"
									v-else
									src="@/assets/communication/pause.svg"
								/>
							</section>

							<div ref="waveformaudio" class="waveform-small"></div>

							<div class="timer font-primary">
								{{ formattedTimeVal }}
							</div>
						</div>
						<b-button
							@click="goToCommunication()"
							class="btn-red d-flex align-items-center w-160px justify-content-center"
						>
							<h2
								class="fs-13 font-secondary pure-white text-h2 font-secondary"
							>
								Retake
							</h2>
						</b-button>
					</section>
				</div>
			</div>
		</div>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="isImageModalOpen"
			:lazy="true"
			:static="true"
		>
			<div class="">
				<img
					:src="previewImage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewImage"
				/>
			</div>
		</b-modal>
		<div
			v-if="isImageModalOpen"
			@click="isImageModalOpen = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/newui-img/test-screen/imagexclose.svg"
				alt=""
			/>
		</div>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="openPreviewMainimagemodal"
			:lazy="true"
			:static="true"
		>
			<div class="">
				<img
					:src="previewMainimage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewMainimage"
				/>
			</div>
		</b-modal>
		<div
			v-if="openPreviewMainimagemodal"
			@click="openPreviewMainimagemodal = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/newui-img/test-screen/imagexclose.svg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
// import { defineComponent } from '@vue/com position-api'
import { isImage, isVideo, isAudio } from "../../checkFileType.js";
// import Media from "@dongido/vue-viaudio";
import { mapGetters } from "vuex";
import eventBus from "@/utils/eventBus.js";
import AnsweredCommuMixin from "@/mixins/answeredCommuMixin";
export default {
	name: "mcqAnswercard",
	components: {
		// Media,
	},
	props: {
		data: Object,
		showindex: Number,
	},
	mixins: [AnsweredCommuMixin],
	data() {
		return {
			markLater: false,
			rad_option: null,
			option: "MCQ",
			showviewicon: null,
			previewImage: null,
			isImageModalOpen: false,
			previewMainimage: null,
			showmainimgviewicon: false,
			openPreviewMainimagemodal: false,
		};
	},
	async created() {
		if (!this.data.answer) {
			this.data.answer = [];
		}
		if (this.data.answerStatus.attempted) {
			this.getAudioData(this.data);
		}
	},
	computed: {
		...mapGetters("sectionVUEX", {
			testDetails: "getTestDetails",
		}),
		...mapGetters("testVUEX", {
			selectedSection: "getSelectedSection",
		}),
		...mapGetters("questionVUEX", {
			currentQuestionData: "getCurrentQuestionData",
		}),
		selectedCount() {
			return this.data.answer.length;
		},
		difficultyLevelText() {
			if (
				this.data.questionBody.difficultyLevel === 1 ||
				this.data.questionBody.difficultyLevel === 2
			) {
				return "Easy";
			} else if (
				this.data.questionBody.difficultyLevel === 3 ||
				this.data.questionBody.difficultyLevel === 4
			) {
				return "Medium";
			} else return "Hard";
		},
	},
	watch: {
		selected() {
			if (this.selected) {
				this.selectedOption();
			}
		},
		data(val) {
			if (val.answerStatus.attempted) {
				this.getAudioData(val);
			}
		},
	},
	methods: {
		goToCommunication() {
			let quesData = this.data;
			//    quesData.questionNo = this.showindex;
			eventBus.$emit("show-communication", quesData);
		},
		isValueExist(option) {
			return (
				option.value != "" && option.value != null && option.value != undefined
			);
		},
		checkColumnText() {
			return this.data.questionBody.options.some((opt) => opt.value);
		},
		openPreviewMainimage(imageUrl) {
			this.previewMainimage = imageUrl;
			this.openPreviewMainimagemodal = true;
		},
		openPreview(imageUrl) {
			this.previewImage = imageUrl;
			this.isImageModalOpen = true;
		},
		isImage,
		isVideo,
		isAudio,
		markforLater() {
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				answer: this.data.answer,
				answerStatus: this.data.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			console.log(payload);

			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		selectedOption() {
			const noAnswer =
				this.data.answer == null ||
				this.data.answer === "" ||
				(Array.isArray(this.data.answer) && this.data.answer.length === 0);

			if (noAnswer) {
				// No answer selected → mark as unattempted
				this.data.answerStatus.active = true;
				this.data.answerStatus.unattempted = true;
				this.data.answerStatus.attempted = false;
			} else {
				// At least one option selected → mark as attempted
				this.data.answerStatus.active = true;
				this.data.answerStatus.unattempted = false;
				this.data.answerStatus.attempted = true;
			}
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				answer: this.data.answer,
				answerStatus: this.data.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
	},
};
</script>

<style>
@import "../../assets/globalcss/style.css";
.mob-radio-group .custom-control-inline {
	width: 50%;
	margin-right: 0px;
}

.mob-radio-group .custom-radio.b-custom-control-sm,
.input-group-sm .custom-radio {
	font-size: 0.875rem;
	line-height: 1.5;
	padding-left: 31px;
	padding-top: 11px;
}

.mob-radio-group .custom-control-label {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #3a3c40;
	max-width: 100%;
	min-width: fit-content;
	word-break: break-all;
	cursor: pointer;
}

.mob-radio-group .custom-control-label::before {
	border: 2px solid #20639b;
}

.mob-radio-group .custom-radio.b-custom-control-sm .custom-control-label::after,
.input-group-sm .custom-radio .custom-control-label::after {
	border: 1px solid #20639b;
	border-radius: 50%;
}

.mob-radio-group .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 4px;
	border-color: #fff;
	background-color: #20639b;
}

.mob-radio-group
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
	border: 2px solid #20639b;
	border-radius: 50%;
}
.mob-chkbx-group .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 0px !important;
	border-color: #20639b !important;
	background-color: #20639b;
}
.mob-chkbx-group
	.custom-checkbox
	.b-custom-control-sm
	.custom-control-label::after,
.mob-chkbx-group .input-group-sm .custom-checkbox .custom-control-label::after {
	top: 0.22rem;
	left: -1.268rem;
	width: 0.875rem;
	height: 0.875rem;
	background-size: 50% 50%;
}
.mob-chkbx-group .input:focus {
	border-color: #20639b !important;
}

.mob-chkbx-group .custom-control-label {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #3a3c40;
	max-width: 100%;
	min-width: -webkit-fit-content;
	min-width: -moz-fit-content;
	min-width: fit-content;
	word-break: break-all;
	cursor: pointer;
	line-height: 22px;
}
.mob-chkbx-group
	.custom-checkbox
	.custom-control-input:focus
	~ .custom-control-label::before {
	box-shadow: none !important;
	outline: none !important;
	border-color: #20639b !important;
}
.mob-chkbx-group
	.custom-control-input[disabled]
	~ .mob-chkbx-group
	.custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
	background-color: #c5c9cc;
	border: 1px solid #20639b;
	cursor: not-allowed;
}
/* .disablecursor .custom-checkbox.b-custom-control-sm .custom-control-label:after,
.input-group-sm .custom-checkbox .custom-control-label:after {
	cursor: not-allowed;
} */
.disablecursor custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
	cursor: not-allowed;
}
.option-media-image {
	width: 140px;
	height: 140px;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 5px;
	overflow: hidden;
}
.br-5px {
	border-radius: 5px;
}

.view-image-icon {
	top: 51px;
	left: 33px;
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 14px;
	color: #ffffff;
	z-index: 2;
}

.mcq-image-modalclose {
	top: 10px;
	right: 10px;
	position: fixed;
	z-index: 11000;
}
#viewimagemodal___BV_modal_backdrop_ {
	background: rgba(52, 64, 84, 0.35);
	backdrop-filter: blur(15px);
	border-radius: 0px;
	opacity: unset;
}
#viewimagemodal .modal-body {
	padding: 0;
}
.border-image {
	border-radius: 10px;
}
.image-blur-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	backdrop-filter: blur(2px); /* blur effect */
	background: rgba(0, 0, 0, 0.5); /* dark overlay */
	z-index: 1;
}
.mark-tag {
	padding: 4px 8px;
	border-radius: 4px;
	background: #ffffff;
	color: #20639b;
	font-size: 11px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
}

.ans-sep {
	width: 16px;
	height: 0px;
	border-width: 1px;
	border: 1px solid #3f698e;
	opacity: 0.5;
	rotate: 90deg;
}

.audio-bar-commu {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	background: #20639b14;
	border-radius: 100px;
	padding: 7px 20px;
	height: 32px;
}

.waveform-small {
	flex: 1;
	height: 10px;
	background: transparent;
	border-radius: 10px;
	margin: 0 15px;
}
.waveform-small > div {
	margin-top: -10px !important;
}
</style>
